import React, { Component, Fragment } from "react";
import { ElementsConsumer, CardElement } from "@stripe/react-stripe-js";
import AppContext from "../../contexts/AppContext";
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import Progress from "./include/Progress";
//import BillingNew from "./include/BillingNew";
//import { processCheckout } from "../../services/checkout";
import Select from "react-select";
import ReactTooltip from "react-tooltip";
import Card from "./include/Card";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { processPayment, setCustomerSubscription } from "../../services/checkout";
import InjectGooglePay from "../payment/GooglePaySubscription";
import {PayPalBtn}   from "../PayPal/subscription/PayPalBtn";
import { getCheckoutStepsData } from "../../services/user";

export class CompleteSteps extends Component {
    
	state = {
        item: {
			fname: this.context.state.user.first_name,
			lname: this.context.state.user.last_name,
			//email: localStorage.getItem('user_email') !== null || localStorage.getItem('user_email') !== undefined ? localStorage.getItem('subscriber_email') : '',
			email: this.context.state.user.email,
			address: '',
			city: '',
			province: '',
			zip: '',
			country: '',
			number: '',
			expiration_year: '',
			expiration_month: '',
			cvc: '',
			agree: false,
			cpn_call: '0',
			card: '',
			province_option_label: '',
			card_holder : '',
			paymentMethodDetails: '',
			stripe: '',
			payment_method_details: 'card-checkout',
			payment_gateway:'',
            subscriptionID:''
        },
		errors: {},
		loading: false,
		cardData: '',
		paymentIntentDetails: '',
		subscriptionDetails: '',
		paymentMethodId: '',
		cardDetails: '',
		confirmCardSetupResult: '',
		showCheckoutButton: true,
		isFormFilled: false,
		paypal_loading:false,
		paypal_annual_plan_id:''
	};
	selectCountry = val => {
		let temp = this.state.item;
        temp['country'] = val;	
		let error = this.state.errors;
        error['country'] = null;

		if (val == 'Canada') {
			temp['province_option_label'] = 'Select Province';
		} else if (val == 'United States') {
			temp['province_option_label'] = 'Select State';
		}

        this.setState({ item: temp, errors: error });
	}
	
	selectRegion = val => {
		let temp = this.state.item;
        temp['province'] = val;	
		let error = this.state.errors;
        error['province'] = null;
        this.setState({ item: temp, errors: error });
	}
	
	onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;		
        let error = this.state.errors;
        error[field.target.name] = null;
        this.setState({ item: temp, errors: error });
	};

	onCardChange = () => {
		this.handleStripeCardSubmit();
	}


	handleStripeCardSubmit = async event => {
		let temp = this.state.item;
		let errors = {};
		const { stripe, elements } = this.props;
		if (!stripe || !elements) {
			return;
		}
		const card = elements.getElement(CardElement);
		const result = await stripe.createToken(card);
		if (result.error) {
			errors.card = result.error.message;
			this.setState({ errors: errors });
			temp['card'] = null;
		}
		else {
			temp['card'] = result.token;
		}

		/*create payment method for 3DS authentication */
		const paymentMethodData = await stripe.createPaymentMethod({
			type: 'card',
			card: card,
		});

		if (paymentMethodData.error) {
			this.setState({ errors: errors });
			temp['paymentMethodDetails'] = null;
		}
		else {
			temp['paymentMethodDetails'] = paymentMethodData.paymentMethod;
		}
		temp['stripe'] = stripe;

		this.setState({ cardDetails: card });

		if (this.state.item.agree) {
			this.setState({ isFormFilled: true })
		}
	}

	handleCheckboxChange = () => {
		let temp = this.state.item;
		temp['agree'] = !temp.agree;
		let error = this.state.errors;
		error['agree'] = !temp.agree ? "Please agree to our terms and conditions." : null;    
		this.setState({ item: temp, errors: error });

		if (this.state.item.card) {
			this.setState({ isFormFilled: true })
		}
	}

	handleValidation = () => {
        let fields = this.state.item; 
        let errors = {};		
        let formIsValid = true;       

        // if(!fields.fname){
        //     formIsValid = false;
        //     errors.fname = "The first name field is required.";
		// }  
		// if(!fields.lname){
        //     formIsValid = false;
        //     errors.lname = "The last name field is required.";
		// } 
		if (!fields.email) {
            formIsValid = false;
            errors.email = "The email field is required.";
		} 
		/*if (!fields.address) {
            formIsValid = false;
            errors.address = "The address field is required.";
		} 
		if (!fields.city) {
            formIsValid = false;
            errors.city = "The city field is required.";
		} 
		if (!fields.province) {
            formIsValid = false;
            errors.province = "The state field is required.";
		} 
		if (!fields.zip) {
            formIsValid = false;
            errors.zip = "The zip field is required.";
		} 
		if (!fields.country) {
            formIsValid = false;
            errors.country = "The country field is required.";
		}*/   

		if (!fields.paymentMethodDetails) {
			formIsValid = false;
			errors.country = "The payment method field is required.";
		}

		if (fields.paymentMethodDetails == 'card-checkout' && !fields.card) {
			errors.card = "Your card number is incomplete.";
			formIsValid = false;
		}
		
		// if(!fields.number){
        //     formIsValid = false;
        //     errors.number = "The number field is required.";
		// }   
		// if(!fields.expiration_year){
        //     formIsValid = false;
        //     errors.expiration_year = "The expiration year field is required.";
		// }  
		// if(!fields.expiration_month){
        //     formIsValid = false;
        //     errors.expiration_month = "The expiration month field is required.";
		// }  
		// if(!fields.cvc){
        //     formIsValid = false;
        //     errors.cvc = "The cvv field is required.";
		// }  

		
		if (!fields.agree) {
            formIsValid = false;
            errors.agree = "Please agree to our terms and conditions.";
        }  
		
        this.setState({errors: errors});        
        return formIsValid;
    } 

	handlePaymentMethodDetailsChange = selectedOption => {
		let value = selectedOption.target.value;

		if (value == 'card-checkout' || value == '') {
			this.setState({ showCheckoutButton: true });
			this.setState({ is_paypal: false });
		} else if(value == 'paypal-checkout' || value == '') {
			this.setState({ showCheckoutButton: false });
            this.setState({ is_paypal: true });
		}else {
            this.setState({ showCheckoutButton: false });
            this.setState({ is_paypal: false });
        }

		let temp = this.state.item;
		temp.payment_method_details = value;
		let error = this.state.errors;
		error.payment_method_details = null;
		this.setState({ item: temp, errors: error });
	}

	componentDidMount() {
		this.context.state.updateMetaData('finish-registration');
		getCheckoutStepsData({ token: "", type: 'pwonbs1' })
            .then(res => {
                if (res.status === true) {
                    // console.log(res);
					// alert(res.meta.paypal_annual_plan_id);
                    this.setState({
                        paypal_annual_plan_id: res.meta.paypal_annual_plan_id,
                    });
                } else {
                    this.setState({ validToken: false });
                }
            })
            .catch(error => {
                this.setState({ validToken: false });
            });
	};
	
	processCheckout = e => {
		e.preventDefault();
		let stripe = this.state.item.stripe;

		if(this.handleValidation())
		{
			this.setState({loading: true});  
			processPayment(this.state.item)
				.then(res => {

					/*confirm card set up for 3DS authentication*/
					stripe.confirmCardSetup(
						res.data.setUpIntentDetails.client_secret,
						{
							payment_method: {
								card: this.state.cardDetails,
								billing_details: {
									name: this.state.item.fname + ' ' + this.state.item.lname,
								},
							},
						}
					).then((confirmCardSetupResult) => {
						if (confirmCardSetupResult.error) {
							this.setState({ loading: false });
							this.context.state.showCodeMessage(confirmCardSetupResult.error.message, 'danger');
						} else {

							if (confirmCardSetupResult.setupIntent.status == 'succeeded') {
								this.setState({ confirmCardSetupResult: confirmCardSetupResult });
								this.setState({ cardDetails: '' });

								/*assigning the newly created payment method to customer and create subscription */
								setCustomerSubscription(this.state).then(setupIntentResult => {
									if (setupIntentResult.status == 200) {
										this.context.state.showCodeMessage(setupIntentResult.data.message, 'success');
										localStorage.setItem('user_steps', 'account');
										localStorage.setItem("user", JSON.stringify(setupIntentResult.data.data));

										if (setupIntentResult.data.meta.token) {
											setTimeout(() => {
												window.location = '/account';
											}, 3000);
										}
									} else {
										this.setState({ loading: false });
										this.context.state.showCodeMessage('Something went wrong. Please try after refreshing the page', 'danger');
									}
								});
							}
						}
					});
				})
				.catch(error => {
					this.setState({ loading: false });
					console.log(error);
					this.context.state.showCodeMessage('Something went wrong. Please try after refreshing the page', 'danger');
					// switch (error.response.status) {
					//     case 422:
					//         if(error.response.data.hasOwnProperty("errors"))
					//         {
					//             this.setState({ errors: error.response.data.errors });
					//         }
					//         else
					//         {
					//             this.setState({ errors: error.response.data.error });
					//         }

					//         break;
					//     default:
					//         this.context.state.handelError(error);
					//         break;
					// }
				});
		}		
	};
	paypalSubscribe = (data, actions) => {
        return actions.subscription.create({
        'plan_id':this.state.paypal_annual_plan_id,
        // 'plan_id': "P-2NJ12907YK1258046MGYMJEY",
        });
    };
    paypalOnError = (err) => {
        console.log("Error");
        console.log(err);
        this.context.state.showCodeMessage('Something went wrong. Please try again.', 'danger');
    };
    payPalOnInit = (data, actions) =>{
        // const note = document.querySelector('.paypal-buttons');
        // note.style.opacity = '0.5';
        // Disable the buttons
        actions.disable();
        // Listen for changes to the checkbox
        document.querySelector('#customCheck')
          .addEventListener('change', function(event) {
  
            // Enable or disable the button when it is checked or unchecked
            if (event.target.checked) {
              actions.enable();
            //   const note = document.querySelector('.paypal-buttons');
            //   note.style.opacity = '';
            } else {
                // const note = document.querySelector('.paypal-buttons');
                // note.style.opacity = '0.5';
              actions.disable();
            }
          });
      };
      payPalOnClick= (data, actions) =>{
        // Show a validation error if the checkbox is not checked
        if (!document.querySelector('#customCheck').checked) {
            let error = this.state.errors;
            error['agree'] = "Please agree to our terms and conditions.";   
            this.setState({errors: error });
        }
      };
  
    paypalOnCancel = (data) => {
          // Show a cancel page, or return to cart
    }
    paypalOnApprove = (data, detail) => {
		this.setState({ paypal_loading: true });
        // call the backend api to store transaction details
        // console.log("Payapl approved")
        // console.log("Data====")
        // console.log(data)
        // console.log("detail====")
        // console.log(detail)
        // console.log(data.subscriptionID)
        if(data.subscriptionID){
            let temp = this.state.item;
            temp['payment_gateway'] = 'paypal';
            temp['subscriptionID'] = data.subscriptionID;
            this.setState({ item: temp});
             /*assigning the newly created payment method to customer and create subscription */
             setCustomerSubscription(this.state).then(paypalResult => {
                console.log(paypalResult);
                if(paypalResult.status ==  200) {
                    this.context.state.showCodeMessage(paypalResult.data.message, 'success');
                    localStorage.setItem('user_steps', 'account');
                    localStorage.setItem("user", JSON.stringify(paypalResult.data.data));

                    if (paypalResult.data.meta.token) {
                        setTimeout(() => {
                            window.location = '/account';
                        }, 3000);
                    }
                } else {
                    this.setState({ loading: false });
                    this.context.state.showCodeMessage('Something went wrong. Please try after refreshing the page', 'danger');
                }
            });
        }
    };
    setPaypal=() => {
        this.setState({ is_paypal: true });
        this.setState({ showCheckoutButton: false });
    }
	render() {
		return (
			
		    <Fragment>
			    <section className="complete-steps py-md-6 py-sm-5 py-4">
				    <div className="container">
				        <h2 className="text-center pb-md-4 pb-0">YOUR <span>FREE</span> TRIAL AWAITS</h2>
				        <div className="row flex-lg-row flex-column align-items-lg-start align-items-center">
				    	    <div className="col-lg-6 col-md-10 order-lg-1 order-2 mt-lg-0 mt-5">
							    <div className="static-info">
								    <div className="title position-relative py-2 px-5 text-white">
									    <span className="position-absolute"><img className="mx-auto d-block" src="/images/logo_dark.png" width="30" height="46" alt="pw-logo"/></span>
										<div className="pl-sm-5 pl-4"><span className="font-weight-bold bg-transparent p-0">ProWriter</span> - Quickly Grow Your Freelance Writing Career!</div>
										<span className="position-absolute"><i className="text-white fas fa-check"></i></span>
									</div>
									<div className="p-md-4 p-3">
									    <p className="mb-3">ProWriter provides you with the must-have tools, strategies, and skills you need to Find, Apply, and Land high-paying writing gigs. Say goodbye to low-paying and low-quality writing clients who don’t value your skill. Sign up right now and get full, immediate access to ProWriter’s library of resources and marketing tools. Heck, you might even land your first paying client today!</p>
										<ul className="row">
										    <li className="col-sm-6 mb-3">
											    <div className="bullet"><img src="/images/JobSearch.png" alt="JobSearch"/></div>
												<span className="font-weight-bold">Premium Jobs Board:</span> Land your dream writing gigs and get paid what you deserve!
											</li>
											<li className="col-sm-6 mb-3">
											    <div className="bullet"><img src="/images/GraduationCap.png" alt="GraduationCap"/></div>
											    <span className="font-weight-bold">Hard Skills Training:</span> Learn critical skills to help you earn the highest payouts!
											</li>
											<li className="col-sm-6 mb-3">
											    <div className="bullet"><img src="/images/Tools.png" alt="Tools"/></div>
											    <span className="font-weight-bold">Marketing Tools:</span> Become a brand and market yourself, skills, and experience!
											</li>
											<li className="col-sm-6 mb-3">
											    <div className="bullet"><img src="/images/NameTag.png" alt="NameTag"/></div>
											    <span className="font-weight-bold">Career Management Insights:</span> Increase productivity and level-up your writing career!
											</li>
											<li className="col-sm-6 mb-sm-0 mb-3">
											    <div className="bullet"><img src="/images/Community.png" alt="Community"/></div>
											    <span className="font-weight-bold">Helpful Community:</span> Join a community of pro writers helping you grow your career!
											</li>
											<li className="col-sm-6">
											    <div className="bullet"><img src="/images/SpecialContent.png" alt="SpecialContent"/></div>
											    <span className="font-weight-bold">Exclusive Content:</span> Access writing assets exclusively available to ProWriter members!
											</li>
										</ul>
									</div>
								</div>
								<div className="static-info">
								    <div className="title position-relative py-2 px-5 text-white">
									    <span className="position-absolute pad-2"><img className="mx-auto d-block" src="/images/membership-1.svg" alt="jobs-board"/></span>
										<div className="pl-sm-5 pl-4"><span className="font-weight-bold bg-transparent p-0">Jobs Board</span> - Easily Find And Land Freelance Writing Jobs!</div>
										<span className="position-absolute"><i className="text-white fas fa-check"></i></span>
									</div>
									<div className="p-md-4 p-3">
									    <p className="mb-3">Where do you get your first writing gigs? Heck, where do you find writing gigs you actually want? Help finding gigs is easily the #1 thing writers ask us about. And it’s a big part of what makes ProWriter special. One of ProWriter’s most valuable and innovative resources is its job search toolkit. Instead of refreshing Indeed.com and digging through technical writing gigs for a gem here and there, our tools help writers:</p>
										<ul className="row">
										    <li className="col-sm-6 mb-3">
											    <div className="bullet"><img src="/images/SearchProperty.png" alt="SearchProperty"/></div>
												<span className="font-weight-bold">Search by industry:</span> Find gigs on the topics you love to write about, and start building your portfolio!
											</li>
											<li className="col-sm-6 mb-3">
											    <div className="bullet"><img src="/images/Target.png" alt="Target"/></div>
											    <span className="font-weight-bold">Focus the job hunt:</span> We aggregate only the best writer gigs from jobs boards all over the web.
											</li>
											<li className="col-sm-6 mb-3">
											    <div className="bullet"><img src="/images/SearchLove.png" alt="SearchLove"/></div>
											    <span className="font-weight-bold">Find unique gigs:</span> Employers post gigs on ProWriter’s jobs board they don’t put anywhere else.
											</li>
											<li className="col-sm-6 mb-3">
											    <div className="bullet"><img src="/images/Bylines.png" alt="Bylines"/></div>
											    <span className="font-weight-bold">Get those first bylines:</span> Looking for bylined opportunities? We manage a portal of outlets accepting submissions.
											</li>
										</ul>
									</div>
								</div>
								<div className="static-info">
								    <div className="title position-relative py-2 px-5 text-white">
									    <span className="position-absolute pad-2"><img className="mx-auto d-block" src="/images/membership-3.svg" alt="Training"/></span>
										<div className="pl-sm-5 pl-4"><span className="font-weight-bold bg-transparent p-0">Training</span> - Become The Writer Every Employer Wants To Hire!</div>
										<span className="position-absolute"><i className="text-white fas fa-check"></i></span>
									</div>
									<div className="p-md-4 p-3">
									    <p className="mb-3">There’s a lot of competition in the freelance writing market. But most writers are simply missing the hard skills it takes to write good content, and every employer knows it. Newer writers also struggle making smart career choices early on. How do you build a professional portfolio? How do you build a name in a niche? How do you write content employers will pay top dollar for? We can help you answer all of these questions, and more.</p>
										<ul className="row">
										    <li className="col-sm-6 mb-3">
											    <div className="bullet"><img src="/images/Profile.png" alt="Profile"/></div>
												<span className="font-weight-bold">A dynamic portfolio:</span> Designed to tell employers everything they need to know: Who you are, what you can do, and where your best work is published.
											</li>
											<li className="col-sm-6 mb-3">
											    <div className="bullet"><img src="/images/Course.png" alt="Courses"/></div>
											    <span className="font-weight-bold">Deep library of courses:</span> We cover everything from content creation skills to career guidance. Watch easy-to-digest short chapters on your time.
											</li>
											<li className="col-sm-6 mb-3">
											    <div className="bullet"><img src="/images/Resources.png" alt="Resources"/></div>
											    <span className="font-weight-bold">Hours of in-depth resources:</span> Want to learn something new on your lunch break? Explore our mini lessons or bookmark our comprehensive guides.
											</li>
											<li className="col-sm-6 mb-3">
											    <div className="bullet"><img src="/images/AskQuestion.png" alt="AskQuestion"/></div>
											    <span className="font-weight-bold">Ask us anything!:</span> Hit us up on chat and benefit from our 10+ years of combined experience as freelance writers, agency owners, and employers.
											</li>
										</ul>
									</div>
								</div>
							</div>
				    		<div className="col-lg-6 col-md-10 mt-lg-0 order-lg-2 order-1">
				    		    <div className="billing-info">
								    <div className="title">
										<h3 className="text-center text-white">Final Step! Confirm & Activate Membership</h3>
										<p className="text-center text-white">50% off first year discount applied. LIMITED TIME ONLY.</p>
									</div>
								    <Progress ariavalue="75" content="75% Complete" width="75%"></Progress>
									<div className="py-4 px-3 bg-grey">
									    <h4 className="text-center px-md-4 px-sm-3 px-2 mb-3">No contracts, downgrade or cancel your account anytime with a single click from your dashboard...</h4>
										<div className="row justify-content-center">
										    <div className="col-auto">
										        <div className="plan-text mt-3">
												    <h4 className="text-center py-3">ProWriter</h4>
													<div className="bg-white p-3 pb-4">
										                <img className="mx-auto d-block mb-3" width="30" height="46" src="/images/logo_dark.png" alt="pw-logo"/>
										        	    <small className="d-block text-center">Sign up now and your account to ProWriter will allow you to land writing jobs, learn writing skills, and so much more! Get started NOW!</small>
                                                        <p className="text-center mt-2"><span className="font-weight-bold">50% Off First Year</span>, then just $94/year</p>
													</div>	
										        </div>
											</div>
										</div>	
									</div>
									<div className="checkout new pt-2 pb-4 px-sm-5 px-3 bg-white">
										<form className="checkout-step-form" onSubmit={this.processCheckout}>
			                                {/* <BillingNew errs={this.state.errors} item={this.state.item} onChangeHandlerFn={this.onChange} selectRegion={this.selectRegion} selectCountry={this.selectCountry}></BillingNew> */}
											{/* <Card onChangeHandlerFn={this.onCardChange} /> */}
											<div className="billing-details">
												<div className="row">
													{/* <div className="col-12">
														<label htmlFor="address" className="font-weight-bold">ADDRESS</label>
														<div className="form-group mb-4">
															<input type="text" onChange={this.onChange} value={this.state.item.address || ''} className="form-control" name="address" id="address" ref="address" placeholder="Full Address..." autoComplete="off" />
															{this.state.errors.address ? (
																<div className="invalid-feedback">
																	{this.state.errors.address}
																</div>
															) : null}
														</div>
													</div>
													<div className="col-12">
														<label htmlFor="city" className="font-weight-bold">CITY</label>
														<div className="form-group mb-4">
															<input type="text" onChange={this.onChange} value={this.state.item.city || ''} className="form-control" name="city" id="city" ref="city" placeholder="City Name..." autoComplete="off" />
															{this.state.errors.city ? (
																<div className="invalid-feedback">
																	{this.state.errors.city}
																</div>
															) : null}
														</div>
													</div>
													<div className="col-12">
														<label htmlFor="country" className="font-weight-bold">COUNTRY</label>
														<div className="form-group select mb-4">
															<CountryDropdown
																defaultOptionLabel="Select Country"
																value={this.state.item.country}
																//whitelist={["CA", "US"]}
																classes="form-control m-input center-select"
																onChange={(val) => this.selectCountry(val)} />
															{this.state.errors.country ? (
																<div className="invalid-feedback">
																	{this.state.errors.country}
																</div>
															) : null}
														</div>
													</div>
													<div className="col-md-8">
														<label htmlFor="state" className="font-weight-bold">STATE</label>
														<div className="form-group select mb-4">
															<RegionDropdown
																blankOptionLabel="State/Province..."
																defaultOptionLabel={this.state.item.province_option_label}
																classes="form-control m-input center-select"
																country={this.state.item.country}
																value={this.state.item.province}
																onChange={(val) => this.selectRegion(val)} />
															{this.state.errors.province ? (
																<div className="invalid-feedback">
																	{this.state.errors.province}
																</div>
															) : null}
														</div>
													</div>
													<div className="col-md-4">
														<label htmlFor="zip" className="font-weight-bold">ZIP</label>
														<div className="form-group mb-4">
															<input type="text" onChange={this.onChange} value={this.state.item.zip || ''} className="form-control" name="zip" id="zip" ref="zip" placeholder="Zip Code..." autoComplete="off" />
															{this.state.errors.zip ? (
																<div className="invalid-feedback">
																	{this.state.errors.zip}
																</div>
															) : null}
														</div>
													</div> */}
													<div className="col-12 mb-2">
														<label htmlFor="payment_method" className="font-weight-bold">PAYMENT METHOD</label>
														<div className="flex-wrap flex-sm-row flex-column align-items-center justify-content-between">
															<div className="row col-sm-auto col-12 interest-block payment-method-holder d-flex align-items-center justify-content-start complete-method-holder">
																<label className="payment-label mr-3">
																	<input type="radio" value="card-checkout" name="payment-method" checked={this.state.item.payment_method_details === 'card-checkout'} onChange={this.handlePaymentMethodDetailsChange} />
																	<div className="payment-label-thumb">
																		<img width="180" height="30" src={`/images/debit.png`} alt="Credit/Debit Card" />
																	</div>
																</label>

																{/* {this.context.state.isAllowedGPay() &&
																	<label className="payment-label mr-lg-0 mr-3">
																		<input type="radio" value="gpay-checkout" name="payment-method" checked={this.state.item.payment_method_details === 'gpay-checkout'} onChange={this.handlePaymentMethodDetailsChange} />
																		<div className="payment-label-thumb">
																			<img width="63" height="30" src={`/images/gpay.png`} alt="Google Pay" />
																		</div>
																	</label>
																} */}
																<label className="payment-label ml-lg-3 ml-0">
																	<input type="radio" value="paypal-checkout" name="payment-method" checked={this.state.item.payment_method_details === 'paypal-checkout'} onChange={this.handlePaymentMethodDetailsChange}/>
																	<div className="payment-label-thumb">
																		<img width="180" className="paypal_img" height="30" src={`/images/paypal.png`} alt="Credit/Debit Card" />    
																		{/* <button onClick={() => {this.setPaypal()}} className="paypal-button">Paypal Subscribe</button>                               */}
																	</div>
																</label>
															</div>
														</div>
													</div>
													
													{this.state.showCheckoutButton &&
														<div className="col-12">
															<label htmlFor="card_holder" className="font-weight-bold">CARD DETAILS</label>
															<span className="why-cc" data-tip data-for='cc'><i className="fa fa-question-circle mr-1"></i>Why do we ask for your credit card?</span>
															<ReactTooltip id='cc' className='why-cc-tooltip' arrowColor='#efba00'>
																<span>We ask for your credit card to prevent interruption of your ProWriter account active once your trial expires. Your credit card will not be charged during your 14-day trial. If you decide that ProWriter isn't for you, you can cancel anytime.</span>
															</ReactTooltip>
														
															<Card onChangeHandlerFn={this.onCardChange} />
															{this.state.errors.card ? (
																<div className="invalid-feedback">
																	{this.state.errors.card}
																</div>
															) : null}

														</div>
													}
													{this.state.showCheckoutButton &&
													<div className="col-12">
														<label htmlFor="card_holder" className="font-weight-bold">CARDHOLDER NAME</label>
														<div className="card-holder form-group position-relative mb-4">
															<input type="text" onChange={this.onChange} value={this.state.item.card_holder || ''} className="form-control" name="card_holder" id="card_holder" ref="card_holder" placeholder="Cardholder Name" autoComplete="off" />
															{this.state.errors.card_holder ? (
																<div className="invalid-feedback">
																	{this.state.errors.card_holder}
																</div>
															) : null}
														</div>
													</div>
													}
													<div className="col-12 mb-4">
													    <label className="font-weight-bold">PLAN TOTAL</label>
														<div className="d-flex align-items-center justify-content-between">
														    <p className="grey-color">Due Today:</p>
															<p className="grey-color">$0.00</p>
														</div>
													</div>
												</div>
											</div>
											{/*<div className="row mt-4 p-0">
					                            <div className="col-12">
					                        	    <div className="one-time-offer p-3">
					                        		    <div className="custom-control custom-checkbox d-flex align-items-center justify-content-center p-2">
                                                            <img className="h-20 mr-3" src="/images/arrow-flash-large.gif" alt="arrow"/>
					                        				<input type="checkbox" className="custom-control-input"  name="add_training" id="add_training" name="add_training"/>
                                                            <label className="custom-control-label" htmlFor="add_training">
					                        		            <span>YES, Add The 9 Secret Funnels Training</span>
					                        		        </label>
					                        		    </div>
					                        			<p className="font-weight-bold mt-2"><span className="font-weight-bold">ONE TIME OFFER</span>: Want our advanced funnel training? Learn the 9 secret funnels and how you can <b>use them to increase sales in any online business</b>. Check YES to add this to your order now for just <strike><b>$197</b></strike> $47 billed today (this offer is not available at ANY other time or place)</p>
					                        		</div>
					                        	</div>
	                                        </div>*/}	
					                        <div className="row mt-3 complete-check">
					                            <div className="col-12">
					                                <small className="d-block">No Sales Tax Applied</small>
													<div className="custom-control custom-checkbox pl-4 agree">
                                                      <input type="checkbox" onChange={this.handleCheckboxChange} checked={this.state.item.agree} className="custom-control-input"  name="agree" id="customCheck" name="example1"/>
                                                      <label className="custom-control-label big" htmlFor="customCheck">
													  First year $47 (50% off), then just $94/year. Cancel through your dashboard or by e-mail (<a href="mailto:support@prowriter.com">support@prowriter.com</a>). I also agree to the <a href="https://www.iubenda.com/privacy-policy/72278847" target="_blank">Privacy Policy</a> and <a href="https://www.iubenda.com/privacy-policy/72278847/cookie-policy">Cookie Policy</a>.
					                        		  </label>
					                        		  {this.state.errors.agree ? (
					                        			<div className="invalid-feedback">
					                        				{this.state.errors.agree}
					                        			</div>
					                        		) : null} 
                                                    </div>
					                        	</div>
                                                <div className={this.props.mobileButtonVisible ? "col-12 sticky-order open mt-4 mb-4  d-flex align-items-center" : "col-12 mt-4 mb-4 d-flex align-items-center"}>
													{this.state.showCheckoutButton && <button type="submit" disabled={this.state.loading} className={"btn btn-primary checkout-process-btn border-0 mx-auto d-block " + (this.state.isFormFilled ? "throb" : '')}>{this.state.loading ? `Processing...` : `Confirm Membership`} <i className={this.state.loading ? `ml-2 fas fa-spinner fa-spin` : `ml-2 fas fa-lock`}></i></button>}
													{!this.state.showCheckoutButton && !this.state.is_paypal && <InjectGooglePay states={this.state} handleFormValidation={this.handleValidation} />}
					                        	</div>
                                                <div className={this.props.mobileButtonVisible ? "col-12 sticky-order open mt-4 mb-4" : "col-12 mt-4 mb-4"}>
													{this.state.is_paypal &&
													<div className="row">
													<div className="col-12">
													{this.state.paypal_loading  == true ?
														<div className="align-items-center text-center">
														<button class="buttonload btn-lg">
															<i class="fa fa-spinner fa-spin"></i> Processing
														</button>
														</div> :
														<div className="align-items-center">
														<PayPalBtn
																onInit={this.payPalOnInit}
																onClick={this.payPalOnClick}
																amount = "0.00"
																currency = "USD"
																createSubscription={this.paypalSubscribe}
																onApprove={this.paypalOnApprove}
																catchError={this.paypalOnError}
																onError={this.paypalOnError}
																onCancel={this.paypalOnCancel}
																/>
														</div>
														}
													</div>
												</div>
												}
					                        	</div>

												<div className="col-12 mb-3 d-flex align-items-center justify-content-center sslImg">
													<img src="/images/ssl-security.png" width="70" height="35" alt="ssl" className="mr-3" />
												    <img src="/images/stripe.png" alt="stripe" width="119" height="35"/>
												</div>
												<div className="col-12 mt-3">
                                                    <small className="special text-center grey-color d-block"><u>Selected Plan</u>: ProWriter Plus  <span className="font-weight-bold">50% Off First Year</span>, then just $94/year</small>
                                                </div>
					                        </div>
										</form>
                                    </div>
								</div>
				    		</div>
				    	</div>
						<div className="testimonial-container mx-auto px-3 mt-5">
						    <div className="row align-items-center">
							    <div className="col-lg-2 col-sm-3 px-md-4 px-2">
								    <img className="w-auto img-fluid" src="/images/JessicaLakritz.png" width="150px"  height="150" alt="image"/>
								</div>
								<div className="col-lg-10 col-sm-9 mt-sm-0 mt-3">
								    <p className="text-dark text-sm-left text-center"><q>My skills as a writer have significantly improved thanks to ProWriter. It’s helped me to write clearly and concisely about pretty much anything. Plus, I’ve also learned SEO skills which have helped me to get my dream clients!</q><span className="d-block text-right font-weight-bold mt-sm-0 mt-3">Jessica Lakritz</span></p>
								</div>
							</div>
						</div>
					</div>
				</section>	
			</Fragment>
			
	     );
        
    }
}

CompleteSteps.contextType = AppContext;
//export default CompleteSteps;

export default function InjectedCheckoutForm() {
	return (
		<ElementsConsumer>
			{({ stripe, elements }) => (
				<CompleteSteps stripe={stripe} elements={elements} />
			)}
		</ElementsConsumer>
	);
} 


// WEBPACK FOOTER //
// ./src/components/general/CompleteSteps.js